import React, { memo } from 'react';
import '../../../styles/commonStyle.css';

interface Props {
    header: string;
    text1: string;
    text2: string;
    text3: string;
    imageSource: string;
}

const CardImageRight: React.FC<Props> = ({ header, text1, text2, text3, imageSource }) => {
    const getCarImage = (carModel: string) => {
        switch (carModel) {
            case "BYD E6":
                return "../../../images/carImages/byde6.jpg";
            case "BYD eMAX7":
                return "../../../images/carImages/BYDeMAX7.jpg";
            case "MG ZS":
                return "../../../images/carImages/MGZS.jpg";
            case "Tata Curvv":
                return "../../../images/carImages/TataCurvv.png";
            default:
            // return require("../../../images/carImages/default.jpg"); // Default image
        }
    }

    return (
        <div className="container-fluid px-0">
            <div className="row justify-content-center mx-0">
                <div className="col-12 px-0 h-100">
                    <div className="h-100 d-flex align-items-center pb-2 p-1 bg-white rounded shadow-sm">
                        <div className="text-container pe-2 flex-grow-1" style={{ flex: 1.2 }}>
                            <h2 className="header m-0 fw-bold fs-6">{header}</h2>
                            <p className="customText m-0">{text1}</p>
                            <p className="customText m-0">{text2}</p>
                            <p className="customText m-0">{text3}</p>
                        </div>

                        <div className="image-container d-flex justify-content-center align-items-center overflow-hidden"
                            style={{ flex: 1.1, height: "110%" }}
                        >
                            <img
                                src={getCarImage(imageSource)}
                                alt={header}
                                className="image img-fluid rounded"
                                style={{
                                    maxWidth: "210px",
                                    maxHeight: "270px",
                                    objectFit: "contain"
                                }}

                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default memo(CardImageRight);
